import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "w-full table-auto" }
const _hoisted_3 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_4 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_5 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_6 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_7 = { class: "px-2 py-6 capitalize md:py-3 whitespace-nowrap" }
const _hoisted_8 = { class: "px-2 py-6 md:py-3 whitespace-nowrap" }
const _hoisted_9 = { class: "px-2 py-2 space-x-3" }
const _hoisted_10 = {
  key: 1,
  class: "relative flex group"
}
const _hoisted_11 = { class: "underline cursor-not-allowed text-blue" }
const _hoisted_12 = { class: "fixed w-64 px-1 m-1 mx-auto text-sm text-gray-100 transition-opacity -translate-x-3 bg-gray-800 rounded-md opacity-0 cursor-not-allowed group-hover:opacity-100 right-0 -translate-y-1/3" }

import { ref } from "vue";
import { storeToRefs } from "pinia";
import { userHasRole } from "@/utils/roles";

import TitleHeader from "@/components/TitleHeader.vue";

import api from "@/api/api";
import { Student } from "@/types";
import { useUserStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChildOutcomesIndex',
  async setup(__props) {

let __temp: any, __restore: any

const { user } = storeToRefs(useUserStore());

const members = ref([] as Student[]);
members.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.students.listStudentsByParent(user.value.id))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.students;

if (!userHasRole(user.value.roles, ['parent', 'brick-club-family'])) {
  window.location.href = "/dashboard";
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('child-outcomes')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("table", _hoisted_2, [
        _createElementVNode("thead", _hoisted_3, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t("name")), 1),
            _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t("brick-club")), 1),
            _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("actions")), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(members.value, (member) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "border-b border-gray-400",
              key: member.id
            }, [
              _createElementVNode("td", _hoisted_7, _toDisplayString(member.first_name) + _toDisplayString(member.middle_name ? ' ' + member.middle_name : '') + " " + _toDisplayString(member.last_name), 1),
              _createElementVNode("td", _hoisted_8, _toDisplayString(member.clubs.length ? member.clubs[0].name : ""), 1),
              _createElementVNode("td", _hoisted_9, [
                (member.survey_permission)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: `/dashboard/children/outcomes/${member.id}`,
                      class: "underline capitalize text-blue"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("view")), 1),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("parent-consent-no-access")), 1)
                    ]))
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}
}

})